import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-layers-slide-home',
  templateUrl: './layers-slide-home.component.html',
  styleUrls: ['./layers-slide-home.component.scss']
})
export class LayersSlideHomeComponent implements OnInit {

  @Input() capas = [];
  @Output() LayerSelected = new EventEmitter<any[]>();

  capasSelected = [];

  constructor() { }

  ngOnInit() {
    const sL =  ['AVC1', 'AVC2', 'AVC3', 'AVC4', 'AVC5', 'AVC6']
    const capas =  this.capas.filter( c => sL.includes(c.label))
    if(capas.length > 0){
      for(let i in capas){
        this.buttonClicked(capas[i]);
      }
    }
    
  }

  buttonClicked(e){
    if(this.capasSelected.includes(e.name)){
      const index = this.capasSelected.indexOf(e.name);
      if (index > -1) { // only splice array when item is found
        this.capasSelected.splice(index, 1); // 2nd parameter means remove one item only
      }
    }else{
      this.capasSelected.push(e.name);
    }
    this.LayerSelected.emit(this.capasSelected);
  }

}
